<template>
  <div class="post-comment-item" v-if="post">
    <div class="comment-header">
      <div class="comment-user">
        <el-tooltip class="item" :disabled="post.owner.title == null" effect="dark" :content="post.owner.title" placement="left-start">
          <img :src="post.owner.profilePicture != null ? post.owner.profilePicture : 'https://via.placeholder.com/200x200'" />
        </el-tooltip>
        <div class="comment-user-title">
          <b>{{ post.owner.fullName }}</b>
          <span> {{ $moment(post.createDate).fromNow() }}</span>
          <!-- <span><i class="fa fa-pen"></i> az önce düzenlendi</span> -->
          <!-- Eğer gönderiyi düzenlemişse -->
        </div>
      </div>

      <el-dropdown trigger="click" class="comment-post-action" @command="handlePostCommand">
        <span class="el-dropdown-link">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="'openRegistration#' + post.id" icon="el-icon-user-solid">{{$t('components.socialhub.comment.openContatRegistration')}}</el-dropdown-item>
          <el-dropdown-item divided :command="'editComment#' + post.id" icon="fas fa-pen">{{$t('components.socialhub.comment.editComment')}}</el-dropdown-item>
          <el-dropdown-item :command="'deleteComment#' + post.id" icon="fas fa-trash">{{$t('components.socialhub.comment.deleteComment')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="post-comment-content" v-html="parseUrl(post.commentText)" v-if="commentEditing == false"></div>
    <div class="post-comment-content-reply" v-if="commentEditing == true && editCommentId == null">
      <div class="mention-area-container" v-dragscroll.x>
        <div class="mention-item" v-for="(mentionedUsers, index) in mentionedUserList" :key="'mentionusers-key-' + index">
          <img :src="mentionedUsers.profilePicture" />
          <span> {{ mentionedUsers.title }} </span>
        </div>
      </div>
      <div class="reply-area-container">
        <el-input type="textarea" :rows="1" placeholder="" v-model="post.commentText"> </el-input>
        <i :class="loading ? 'el-icon-loading' : 'el-icon-s-promotion'"></i>
      </div>
      <div class="post-comment-relpy-actions">
        <span @click="closeEditing">{{$t('components.socialhub.comment.cancel')}}</span>
      </div>
    </div>
    <div class="comment-engagement">
      <div class="comment-actions">
        <!-- <span>{{ $moment(post.createDate).fromNow() }}</span> -->
        <span class="comment-show" @click="showSubComments = !showSubComments">{{ post.subCommentCount }} {{$t('components.socialhub.comment.comment')}}</span>
        <!-- subCommentCommentCount > 0 -->
        <span class="comment-reply" @click="openCommentReply" :class="commentEditing ? 'comment-button-disbled' : ''">
          {{ commentReply ? $t('components.socialhub.comment.cancel') : $t('components.socialhub.comment.reply') }}
        </span>
      </div>

      <div class="comment-like">
        <el-popover placement="top" width="200" trigger="click">
          <template>
            <div class="like-popover">
              <div class="like-user-item" v-for="(likedusers, index) in mentionedUserList" :key="'likedUsers-key' + index">
                <el-tooltip class="item" :disabled="likedusers.title == null" effect="dark" :content="likedusers.title" placement="left-start">
                  <img :src="likedusers.profilePicture != null ? likedusers.profilePicture : 'https://via.placeholder.com/200x200'" />
                </el-tooltip>
                <span> {{ likedusers.title }} </span>
              </div>

              <!-- Load commentsLikes -->
              <infinite-loading @infinite="getCommentsLikeData">
                <div slot="no-more">
                  <span> {{$t('components.socialhub.comment.noMoreLikes')}}</span>
                </div>

                <div slot="no-results">
                  <span> {{$t('components.socialhub.comment.noLikes')}} </span>
                </div>
              </infinite-loading>
            </div>
          </template>
          <span slot="reference">{{ post.likeCount }} {{$t('components.socialhub.comment.like')}}</span>
          <!-- commentLikeCount > 0 değilse Beğen yazacak-->
        </el-popover>

        <i :class="(loading == 'postLikeLoading' ? 'el-icon-loading' : 'fa fa-heart') + ' ' + (post.isLiked ? 'isLiked' : '')" @click="likedComment"></i>
      </div>
    </div>

    <!-- Add or reply comments -->
    <div class="post-comment-content-reply" v-if="commentReply == true && editCommentId == null">
      <div class="mention-area-container" v-dragscroll.x>
        <div class="mention-item" v-for="(mentionedUsers, index) in mentionedUserList" :key="'mentionesusers-key-' + index">
          <img :src="mentionedUsers.profilePicture" />
          <span> {{ mentionedUsers.title }} </span>
        </div>
      </div>

      <div class="reply-area-container">
        <el-input type="textarea" :rows="1" placeholder="" v-model="commentReplyObj.commentText"> </el-input>
        <i :class="loading == 'commentReply' ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="addCommentReply"></i>
      </div>

      <div class="post-comment-relpy-actions">
        <span @click="openCommentReply">{{$t('components.socialhub.comment.cancel')}}</span>
      </div>
    </div>
    <div class="post-comments sub-comments" v-if="showComments == true && showSubComments == true">
      <div class="post-comment-item" v-for="(item, index) in subCommentList" :key="item.id + '-subcomment' + index">
        <div class="comment-header">
          <div class="comment-user">
            <el-tooltip class="item" :disabled="item.owner.title == null" effect="dark" :content="item.owner.title" placement="left-start">
              <img :src="item.owner.profilePicture != null ? item.owner.profilePicture : 'https://via.placeholder.com/200x200'" />
            </el-tooltip>
            <div class="comment-user-title">
              <b>{{ item.owner.fullName }}</b>
              <span><i class="fa fa-pen"></i> {{$t('components.socialhub.comment.justEdited')}}</span>
            </div>
          </div>

          <el-dropdown trigger="click" class="comment-post-action" @command="handlePostCommand">
            <span class="el-dropdown-link">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="'openRegistration#' + item.id" icon="el-icon-user-solid">{{$t('components.socialhub.comment.openContactRecord')}}</el-dropdown-item>
              <el-dropdown-item divided :command="'editSubComment#' + item.id" icon="fas fa-pen">{{$t('components.socialhub.comment.editReply')}}</el-dropdown-item>
              <el-dropdown-item :command="'deleteSubComment#' + item.id" icon="fas fa-trash">{{$t('components.socialhub.comment.deleteReply')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="post-comment-content" v-html="parseUrl(item.commentText)" v-if="commentEditing == false"></div>
        <div class="post-comment-content-reply" v-if="commentEditing == true && editCommentId == item.id">
          <div class="mention-area-container" v-dragscroll.x>
            <div class="mention-item" v-for="(mentionedUsers, index) in mentionedUserList" :key="'1mentionedUsers-' + index">
              <img :src="mentionedUsers.profilePicture" />
              <span> {{ mentionedUsers.title }} </span>
            </div>
          </div>

          <div class="reply-area-container">
            <el-input type="textarea" :rows="1" placeholder="" v-model="subCommentReplyObj.commentText"> </el-input>
            <i :class="loading == 'subCommentReply-' + item.id ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="addSubCommentItem(item)"></i>
          </div>

          <div class="post-comment-relpy-actions">
            <span @click="closeEditing">{{$t('components.socialhub.comment.cancel')}}</span>
          </div>
        </div>

        <div class="comment-engagement">
          <div class="comment-actions">
            <span>{{$t('components.socialhub.comment.justNow')}}</span>
            <span class="comment-reply" @click="openSubCommentReply(item.id, item)" :class="commentEditing ? 'comment-button-disbled' : ''">
              {{ commentReply ? $t('components.socialhub.comment.cancel') : $t('components.socialhub.comment.reply') }}
            </span>
          </div>
          <div class="comment-like">
            <el-popover placement="top" width="200" trigger="click">
              <template>
                <div class="like-popover">
                  <div class="like-user-item" v-for="(likedusers, index) in mentionedUserList" :key="'2likedusers-' + index">
                    <el-tooltip class="item" :disabled="likedusers.title == null" effect="dark" :content="likedusers.title" placement="left-start">
                      <img :src="likedusers.profilePicture != null ? likedusers.profilePicture : 'https://via.placeholder.com/200x200'" />
                    </el-tooltip>
                    <span> {{ likedusers.title }} </span>
                  </div>
                </div>
              </template>
              <span slot="reference">{{ item.likeCount }} {{$t('components.socialhub.comment.like')}}</span>
              <!-- subCommentLikeCount > 0 değilse Beğen yazacak-->
            </el-popover>
            <i :class="(loading == 'subLikeLoading-' + item.id ? 'el-icon-loading' : 'fa fa-heart') + ' ' + (item.isLiked ? 'isLiked' : '')" @click="likeSubComment(item)"></i>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center w-100 mb-2"><el-button @click="getCommentList" :loading="loading == 'subCommentLoading'" v-if="!lockedButton" round type="primary" icon="fas fa-plus" size="mini">{{$t('components.socialhub.comment.loadOldComments')}}</el-button></div>
    </div>
    <!-- Load SubComments -->
  </div>
</template>

<script>
  import { dragscroll } from 'vue-dragscroll';
  export default {
    directives: {
      dragscroll,
    },
    props: ['post', 'mentionedUserList', 'postId', 'showComments','subCommentList'],
    data() {
      return {
        subCommentReplyObj: {
          id: null,
          postId: null,
          commentText: null,
          parentId: null,
          mentions: [],
        },
        lockedButton: false,
        isLiked: true,
        commentReplyObj: {
          id: null,
          postId: null,
          commentText: null,
          parentId: null,
          mentions: [],
        },
        infiniteId: new Date(),
        likes: [],
        commentEditing: false,
        loading: false,
        timeout: null,
        showSubComments: false,
        commentReply: false,
        commentsFilter: {
          skip: 0,
          take: 5,
          searchTerm: null,
          ids: [],
          postId: null,
          parentId: null,
        },
        editCommentId: null,
      };
    },
    async created() {
      await this.getCommentList();
   
      var channelId = 'event-social-hub-' + this.$store.state.event.event.id;
      this.$socket.on(channelId + '-postCommentDeleted', (data) => {
        var socketData = this.$toCamel(data.data);
        var fIndex = this.subCommentList.findIndex((x) => x.id == data.data.CommentId);
        if (fIndex != -1) {
          this.subCommentList.splice(fIndex, 1);
        }
      });
      // this.$socket.off(channelId + '-postCommentLikeCountChanged');
      this.$socket.on(channelId + '-postCommentLikeCountChanged', (data) => {
        var socketData = this.$toCamel(data.data);
        if (this.post.id == socketData.commentId) {
          this.post.likeCount = socketData.likeCount;
        }
        var fIndex = this.subCommentList.findIndex((x) => x.id == data.data.CommentId);
        if (fIndex != -1) {
          this.subCommentList[fIndex].likeCount = socketData.likeCount;
        }
      });

      this.$socket.on(channelId + '-newComment', (data) => {
        var socketData = data.data;
        if (socketData.Comment.ParentId == this.post.id) {
          this.subCommentList.unshift(this.$toCamel(socketData.Comment));
        }
      });
    },
    methods: {
      async addSubCommentItem(item) {
        this.subCommentReplyObj.postId = this.postId;
        this.subCommentReplyObj.parentId = this.post.id;
        this.loading = 'subCommentReply-' + item.id;
        var res = await this.$store.dispatch('socialHubAddUpdateComment', this.subCommentReplyObj);
        if (!res.data.alert.hasError) {
          this.commentEditing = false;
          this.commentReplyChanged(this.commentEditing);
          this.subCommentReplyObj.commentText = null;
        }
        this.loading = false;
      },
      async getCommentList() {
        this.loading = 'subCommentLoading';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          this.commentsFilter.postId = this.postId;
          this.commentsFilter.parentId = this.post.id;
          var res = await this.$store.dispatch('socialHubListComments', this.commentsFilter);
          if (!res.data.alert.hasError) {
            if (res.data.data.items.length > 0) {
              this.commentsFilter.skip = this.commentsFilter.take;
              this.commentsFilter.take = this.commentsFilter.skip * 2;
              this.subCommentList.push(...res.data.data.items);
            } else {
              this.lockedButton = true;
            }
          }
          this.loading = false;
        }, 500);
      },
      async likeSubComment(item) {
        this.loading = 'subLikeLoading-' + item.id;
        var payload = {
          id: item.id,
          isLiked: !item.isLiked,
          postId: this.postId,
        };
        var res = await this.$store.dispatch('socialHubToggleLikeComment', payload);
        if (!res.data.alert.hasError) {
          item.likeCount = res.data.data.likes;
          item.isLiked = payload.isLiked;
        }
        this.loading = false;
      },
      async likedComment() {
        this.loading = 'postLikeLoading';
        var payload = {
          id: this.post.id,
          isLiked: !this.post.isLiked,
          postId: this.postId,
        };
        var res = await this.$store.dispatch('socialHubToggleLikeComment', payload);
        if (!res.data.alert.hasError) {
          this.post.likeCount = res.data.data.likes;
          this.post.isLiked = payload.isLiked;
        }
        this.loading = false;
      },
      async addCommentReply() {
        this.commentReplyObj.postId = this.postId;
        this.commentReplyObj.parentId = this.post.id;
        this.loading = 'commentReply';
        var res = await this.$store.dispatch('socialHubAddUpdateComment', this.commentReplyObj);
        if (!res.data.alert.hasError) {
          this.commentReply = false;
          this.commentReplyObj.commentText = null;
          this.commentReplyChanged(this.commentReply);
        }
        this.loading = false;
      },
      getCommentsLikeData($state) {
        $state.complete();
      },
      openCommentReply() {
        this.commentReply = !this.commentReply;
        this.commentReplyChanged(this.commentReply);
      },
      openSubCommentReply(id, item) {
        this.commentEditing = !this.commentEditing;
        this.commentReplyChanged(this.commentEditing);
        this.editCommentId = id;
        this.subCommentReplyObj.commentText = '@' + item.owner.fullName + ' ';
      },
      closeEditing() {
        this.editCommentId = null;
        this.commentEditing = !this.commentEditing;
        this.commentReplyChanged(this.commentEditing);
      },
      async handlePostCommand(command) {
        var comm = command.split('#')[0];
        var uid = command.split('#')[1];
        switch (comm) {
          case 'editComment':
            this.commentEditing = !this.commentEditing;
            this.commentReplyChanged(this.commentEditing);
            break;
          case 'editSubComment':
            this.commentEditing = !this.commentEditing;
            this.commentReplyChanged(this.commentEditing);
            this.editCommentId = uid;
            break;
          case 'deleteComment':
            await this.$store.dispatch('socialHubDeleteComment', uid);

            break;
          case 'deleteSubComment':
            await this.$store.dispatch('socialHubDeleteComment', uid);
            break;
        }
      },
      parseUrl(text, post) {
        if (text == null) {
          return '';
        }
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        var usernameRegex = /\%(.*?)\%/g;
        var standName = /\#(.*?)\#/g;
        text = text.replace(urlRegex, function(url) {
          return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });

        text = text.replace(usernameRegex, function(url) {
          var user = null;

          if (post.taggedUsers != null && post.taggedUsers.some((k) => k.id == url.replace('%', '').replace('%', ''))) {
            var user = post.taggedUsers.find((k) => k.id == url.replace('%', '').replace('%', ''));
            return '<a href="javascript:;" user-id="' + url.replace('%', '').replace('%', '') + '" class="open-url">' + user.title + '</a>';
          } else {
            return url;
          }
        });

        text = text.replace(standName, function(url) {
          var user = null;

          if (post.taggedStands != null && post.taggedStands.some((k) => k.id == url.replace('#', '').replace('#', ''))) {
            var user = post.taggedStands.find((k) => k.id == url.replace('#', '').replace('#', ''));
            return '<a href="javascript:;" user-id="' + url.replace('#', '').replace('#', '') + '" class="open-url">' + user.title + '</a>';
          } else {
            return url;
          }
        });

        return text;
      },
    },
    watch: {
      commentReply: function() {
        this.$emit('editComment', this.commentReply);
      },
      commentEditing: function() {
        if (!this.commentEditing) {
          this.commentReply = false;
          this.subCommentReplyObj.commentText = null;
        }
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/socialhub/Comment.vue